export * from "./locales/en";
export * from "./locales/fr";
